import { addDoc, collection, deleteDoc, doc, getDocs, query, serverTimestamp, setDoc, where } from 'firebase/firestore';
import { db } from '@/config/firebase';
import type { SessaoOnboarding } from './onboardingPresenca';

const COLECAO = 'si_onboarding_sessoes';

export type SessaoOnboardingDados = Omit<SessaoOnboarding, 'id' | 'criadoPor' | 'criadoEm' | 'atualizadoEm'>;

/** Sessões de onboarding (presença) — só o SI lê e grava (firestore.rules). */
export const onboardingSessaoService = {
  async listarPorDocumento(documentoId: string): Promise<SessaoOnboarding[]> {
    const snap = await getDocs(query(collection(db, COLECAO), where('documentoId', '==', documentoId)));
    return snap.docs
      .map((d) => ({ id: d.id, ...d.data() }) as SessaoOnboarding)
      .sort((a, b) => `${b.data} ${b.inicio}`.localeCompare(`${a.data} ${a.inicio}`));
  },

  /** Sem `id` cria; com `id` atualiza (mantém quem criou). */
  async salvar(sessao: SessaoOnboardingDados & { id?: string }, por: { id: string; name: string }): Promise<void> {
    const { id, ...dados } = sessao;
    if (id) {
      await setDoc(doc(db, COLECAO, id), { ...dados, atualizadoEm: serverTimestamp() }, { merge: true });
      return;
    }
    await addDoc(collection(db, COLECAO), { ...dados, criadoPor: por, criadoEm: serverTimestamp(), atualizadoEm: serverTimestamp() });
  },

  async excluir(id: string): Promise<void> {
    await deleteDoc(doc(db, COLECAO, id));
  },
};
